import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  icon: {
    width: "14px !important",
    padding: "0px 2px 0px 12px",
    verticalAlign: "middle",
    color: "#1E49E2",
  },
  editText: {
    color: "#1E49E2",
    cursor: "pointer",
  },
}));
